<template>
  <!-- <footer>
    <section>
      <div class="container text-center">
        <a href="index.php">
          <img
            src="../assets/images/logotipo-z-incorporacoes-rodape.png"
            alt="Logotipo Z Incorporações"
            class="img-fluid"
            width="520"
            title="Logotipo Z Incorporações"
          />
        </a>
        <div class="row justify-content-md-start justify-content-md-center">
          <div class="text-white col-sm-212 col-md-10 col-lg-7">
            <p class="pb-3 text-center">
              <br />
              <a class="color-default" href="mailto:contato@zmaisconstrutora.com.br">contato@zmaisconstrutora.com.br</a><br />
              Av. Rodrigues Alves, 34-53 • 17030-000 • Bauru/SP<br />
              Telefone:
              <a class="color-default" href="tel:+551421065756"
                >(14) 2106-5756</a
              ><br />
            </p>
          </div>
        </div>
      </div>
    </section>
  </footer> -->
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="less" scoped>
footer {
  padding: 75px 0;
  background-color: #000000;
  margin-top: 50px;
  .color-default {
    color: #00C48C;
    text-decoration: none;
    position: relative;
    &::after {
      content: '';
      height: 1px;
      width: 0;
      background: #00C48C;
      position: absolute;
      left: 0;
      bottom: 0;
      transition: all .2s linear;
    }
    &:hover {
      color: #0d7658;
      &::after {
        width: 100%;
        background: #0d7658;
      }
    }
  }
  .text-min {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue